import { Button } from "@/components/ui/button";
import { useRef } from "react";
import { motion } from "framer-motion";

const Hero = () => {
  const cardRef = useRef<HTMLDivElement>(null);
  const handleMove = (e: React.MouseEvent) => {
    const card = cardRef.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    card.style.setProperty("--mx", `${x}px`);
    card.style.setProperty("--my", `${y}px`);
  };
  return (
    <section id="home" aria-label="Hero" className="relative grain-overlay bg-canvas overflow-hidden">
      {/* Organic blob shapes — personality layer */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
        <svg className="absolute -top-40 -right-40 opacity-[0.07] text-accent" width="700" height="700" viewBox="0 0 700 700" fill="currentColor">
          <path d="M350,60 C450,40 580,120 620,240 C670,380 620,520 510,580 C400,640 240,610 160,510 C80,410 80,270 150,170 C210,80 260,80 350,60Z" />
        </svg>
        <svg className="absolute -bottom-24 -left-24 opacity-[0.05] text-primary" width="500" height="500" viewBox="0 0 500 500" fill="currentColor">
          <path d="M250,40 C320,20 410,80 440,170 C480,280 440,390 360,430 C280,470 170,450 110,370 C50,290 60,180 120,110 C170,50 190,55 250,40Z" />
        </svg>
      </div>

      <div
        className="min-h-[70vh] md:min-h-[85vh] bg-cover bg-center"
        style={{ backgroundImage: `url(/lovable-uploads/38764b79-2359-498d-9218-eaee5e758285.png)` }}>
        
        <div className="container mx-auto flex items-center justify-center px-4 sm:px-6 py-16 md:py-24">
          <div
            ref={cardRef}
            onMouseMove={handleMove}
            className="relative w-full max-w-4xl rounded-2xl bg-primary text-primary-foreground shadow-2xl p-5 sm:p-8 md:p-12 overflow-hidden">
            
            <div
              aria-hidden
              className="pointer-events-none absolute inset-0 rounded-2xl"
              style={{
                background:
                "radial-gradient(640px circle at var(--mx,50%) var(--my,50%), hsl(var(--primary-glow) / 0.32), hsl(var(--accent) / 0.16), transparent 46%)"
              }} />
            
            <div className="relative grid md:grid-cols-3 gap-6 md:gap-10 items-center">
              <div className="md:col-span-2">
                <motion.div
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4 }}
                  className="inline-flex items-center gap-2 bg-primary-foreground/10 border border-primary-foreground/20 rounded-full px-3 py-1 text-sm font-medium mb-4">
                  
                  <span className="size-2 rounded-full bg-green-400 animate-pulse" aria-hidden />
                  Live in 5 days. Fixed price.
                </motion.div>
                <motion.h1
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                  className="text-2xl font-bold font-display leading-tight mb-4 sm:text-3xl md:text-4xl">What would you do with 10 extra hours a week?


                </motion.h1>
                <motion.p
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="text-lg md:text-xl text-primary-foreground/90 mb-6">I build AI systems for NJ small businesses — the leads, the scheduling, the busywork. Handled.


                </motion.p>
                <motion.p
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.4, delay: 0.3 }}
                  className="text-sm text-primary-foreground/70 mb-6">Based in Montclair. Serving New Jersey small businesses.


                </motion.p>
                <motion.div
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.35 }}>
                  
                  <Button variant="hero" size="lg" asChild className="w-full sm:w-auto text-sm sm:text-base">
                    <a href="#contact">Book a Free 15-Min Consultation</a>
                  </Button>
                </motion.div>
              </div>
              <div className="md:col-span-1">
                <img
                  src="/lovable-uploads/768b2d45-ff22-404c-8109-399db842292a.png"
                  alt="Team collaborating in a bright office"
                  loading="lazy"
                  className="w-full h-48 md:h-56 object-cover rounded-xl ring-1 ring-primary/20 shadow-lg" />
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};
export default Hero;